import { render, staticRenderFns } from "./AccountSettingsEditCompanyForm.vue?vue&type=template&id=68971cd6&"
import script from "./AccountSettingsEditCompanyForm.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsEditCompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports